import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { confirmPopup } from "primereact/confirmpopup";
import { deleteWork, fetchOurWorks } from "../../redux/actions/ourWorkAction";
import { getServices } from "../../redux/actions/serviceAction";

export default function Index() {
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchOurWorks());
        dispatch(getServices());
    }, [dispatch]);

    let { ourWork } = useSelector((state) => state.work);
    let { allServices } = useSelector((state) => state.service);

    const [search, setSearch] = useState("");

    const getFilteredData = (data, search) => {
        if (search.length) {
            data = data.filter(
                (item) => item?.name?.toLowerCase()?.includes(search.toLowerCase()) || item?.details?.toLowerCase()?.includes(search.toLowerCase())
            );
        }
        return data;
    };

    ourWork = getFilteredData(ourWork, search);

    const onDelete = (e, id) => {
        confirmPopup({
            target: e.currentTarget,
            message: "Are you sure you want to delete this work? This action will permanently delete the user account. This action cannot be undone.",
            icon: "pi pi-exclamation-triangle",
            accept: () => dispatch(deleteWork(id)),
            reject: () => {},
        });
    };

    return {
        ourWork,
        history,
        search,
        setSearch,
        dispatch,
        onDelete,
        allServices,
    };
}
